/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SkuProductResVo
 */
export interface SkuProductResVo {
    /**
     * 主键ID
     * @type {number}
     * @memberof SkuProductResVo
     */
    id?: number;
    /**
     * 商品URL
     * @type {string}
     * @memberof SkuProductResVo
     */
    productUrl?: string;
    /**
     * 商品图片URL
     * @type {string}
     * @memberof SkuProductResVo
     */
    imageUrl?: string;
    /**
     * 颜色
     * @type {string}
     * @memberof SkuProductResVo
     */
    color?: string;
    /**
     * 尺寸
     * @type {string}
     * @memberof SkuProductResVo
     */
    size?: string;
    /**
     * 单价
     * @type {number}
     * @memberof SkuProductResVo
     */
    unitPrice?: number;
    /**
     * 构成数量
     * @type {number}
     * @memberof SkuProductResVo
     */
    productNumber?: number;
    /**
     * 通关类目ID
     * @type {number}
     * @memberof SkuProductResVo
     */
    ctmsItemId?: number;
    /**
     * 通关类目名称
     * @type {string}
     * @memberof SkuProductResVo
     */
    ctmsItemName?: string;
    /**
     * 通关类目路径
     * @type {string}
     * @memberof SkuProductResVo
     */
    categoryPath?: string;
    /**
     * 海关商品英文名
     * @type {string}
     * @memberof SkuProductResVo
     */
    coProNmEn?: string;
    /**
     * 海关编码
     * @type {string}
     * @memberof SkuProductResVo
     */
    coHsCode?: string;
    /**
     * 启用状态：0-不可用，1-可用
     * @type {number}
     * @memberof SkuProductResVo
     */
    enable?: number;
    /**
     * 创建时间
     * @type {string}
     * @memberof SkuProductResVo
     */
    createTime?: string;
    /**
     * 修改时间
     * @type {string}
     * @memberof SkuProductResVo
     */
    updateTime?: string;
}

/**
 * Check if a given object implements the SkuProductResVo interface.
 */
export function instanceOfSkuProductResVo(value: object): value is SkuProductResVo {
    return true;
}

export function SkuProductResVoFromJSON(json: any): SkuProductResVo {
    return SkuProductResVoFromJSONTyped(json, false);
}

export function SkuProductResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SkuProductResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'productUrl': json['productUrl'] == null ? undefined : json['productUrl'],
        'imageUrl': json['imageUrl'] == null ? undefined : json['imageUrl'],
        'color': json['color'] == null ? undefined : json['color'],
        'size': json['size'] == null ? undefined : json['size'],
        'unitPrice': json['unitPrice'] == null ? undefined : json['unitPrice'],
        'productNumber': json['productNumber'] == null ? undefined : json['productNumber'],
        'ctmsItemId': json['ctmsItemId'] == null ? undefined : json['ctmsItemId'],
        'ctmsItemName': json['ctmsItemName'] == null ? undefined : json['ctmsItemName'],
        'categoryPath': json['categoryPath'] == null ? undefined : json['categoryPath'],
        'coProNmEn': json['coProNmEn'] == null ? undefined : json['coProNmEn'],
        'coHsCode': json['coHsCode'] == null ? undefined : json['coHsCode'],
        'enable': json['enable'] == null ? undefined : json['enable'],
        'createTime': json['createTime'] == null ? undefined : json['createTime'],
        'updateTime': json['updateTime'] == null ? undefined : json['updateTime'],
    };
}

export function SkuProductResVoToJSON(json: any): SkuProductResVo {
    return SkuProductResVoToJSONTyped(json, false);
}

export function SkuProductResVoToJSONTyped(value?: SkuProductResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'productUrl': value['productUrl'],
        'imageUrl': value['imageUrl'],
        'color': value['color'],
        'size': value['size'],
        'unitPrice': value['unitPrice'],
        'productNumber': value['productNumber'],
        'ctmsItemId': value['ctmsItemId'],
        'ctmsItemName': value['ctmsItemName'],
        'categoryPath': value['categoryPath'],
        'coProNmEn': value['coProNmEn'],
        'coHsCode': value['coHsCode'],
        'enable': value['enable'],
        'createTime': value['createTime'],
        'updateTime': value['updateTime'],
    };
}

